import React from 'react';
export function Header() {
  return <header className="sticky top-0 z-50 bg-black text-white shadow-md" data-id="element-214">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center" data-id="element-215">
        <div className="font-serif text-2xl italic" data-id="element-216">The Health Times</div>
        <nav className="hidden md:flex space-x-8" data-id="element-217">
          <a href="#benefits" className="hover:text-blue-500 transition duration-300" data-id="element-218">
            Benefits
          </a>
          <a href="#ingredients" className="hover:text-blue-500 transition duration-300" data-id="element-219">
            Ingredients
          </a>
          <a href="#testimonials" className="hover:text-blue-500 transition duration-300" data-id="element-220">
            Testimonials
          </a>
          <a href="#pricing" className="hover:text-blue-500 transition duration-300" data-id="element-221">
            Pricing
          </a>
        </nav>
        <a href="https://the247alpha.com/products/alpha-energy?variant=52325407719751" className="bg-blue-800 hover:bg-blue-900 text-white px-4 py-2 rounded-md font-medium transition duration-300" data-id="element-222">
          ORDER NOW
        </a>
      </div>
    </header>;
}